import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DesignGraphiquePage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function DesignGraphiquePage() {
    const navigate = useNavigate();

    return (
        <div className="design-graphique-page">
            <Header />

            {/* Hero Section */}
            <section className="design-hero">
                    <div className="design-hero-wrapper">
                        <div className="design-hero-container">
                            <h1 className="design-hero-title">
                                Design Graphique &amp; Branding créatifs <span className="design-hero-highlight">assistés par IA</span>
                            </h1>
                            <p className="design-hero-text">
                                Chez Viviworks.AI, nous combinons la créativité de nos designers avec la puissance de l'intelligence artificielle pour créer des expériences visuelles uniques et percutantes.
                            </p>
                            <p className="design-hero-text">
                                L'IA devient un outil de création et d'innovation qui permet d'analyser les tendances, d'anticiper les besoins visuels et de générer des concepts originaux, offrant ainsi une approche créative plus intelligente et plus performante.
                            </p>
                            <p className="design-hero-text">
                                Il ne s'agit pas de remplacer la créativité humaine mais de l'augmenter. L'objectif est de créer des visuels performantes, cohérentes et imprégnés d'identité marquée.
                            </p>

                            <button className="design-hero-button" onClick={() => navigate('/#contact')}>
                                Contactez nous
                            </button>
                        </div>
                    </div>
                </section>

                {/* Grid Section */}
                <section className="design-grid-section">
                    <div className="design-grid-wrapper">
                        <div className="design-grid-container">
                            <div className="design-grid">
                                {/* Card 1 */}
                                <div className="design-card design-card-left">
                                    <h2 className="design-card-title">
                                        Identité visuelle &amp; logo <span className="design-card-highlight">design</span>
                                    </h2>
                                    <p className="design-card-text">
                                        L'identité visuelle est bien plus qu'un simple logo, c'est l'expression visuelle de votre marque.
                                    </p>
                                    <p className="design-card-text">
                                        Grâce à l'IA, nous analysons votre secteur d'activité, votre cible et vos valeurs, pour créer un univers graphique cohérent qui reflète votre ADN.
                                    </p>
                                    <p className="design-card-text">
                                        Notre approche unique combine des tendances de design modernes avec des algorithmes d'analyse sémantique et de tendance créative.
                                    </p>
                                    <p className="design-card-text">
                                        Nous créons des logos mémorables, des palettes de couleurs impactantes et des typographies au service de votre communication pour que votre marque se démarque instantanément, même dans l'écosystème digital saturé.
                                    </p>
                                </div>

                                {/* Card 2 */}
                                <div className="design-card design-card-right">
                                    <h2 className="design-card-title">
                                        <span className="design-card-highlight">Génération</span> d'idées visuelles via IA
                                    </h2>
                                    <p className="design-card-text">
                                        L'intelligence artificielle nous permet de générer rapidement des concepts visuels innovants.
                                    </p>
                                    <p className="design-card-text">
                                        Elle aide à explorer des tendances de couleurs, des compositions visuelles et des styles graphiques, bien au-delà de ce que permettait auparavant une approche traditionnelle.
                                    </p>
                                    <p className="design-card-text">
                                        Création d'idées d'abord et d'itération en quelques secondes propulsent les processus créatifs.
                                    </p>
                                    <p className="design-card-text">
                                        Nous ne nous contentons pas de générer, nous sélectionnons, affinons et optimisons chaque proposition en fonction de vos valeurs d'entreprise et vos objectifs stratégiques, pour un résultat alliant performance et esthétique.
                                    </p>
                                </div>

                                {/* Card 3 */}
                                <div className="design-card design-card-left">
                                    <h2 className="design-card-title">
                                        Création humaine raffinée à partir de <span className="design-card-highlight">concepts IA</span>
                                    </h2>
                                    <p className="design-card-text">
                                        Chez Viviworks.AI, nous croyons en la symbiose parfaite entre l'humain et la machine.
                                    </p>
                                    <p className="design-card-text">
                                        L'intelligence artificielle propose des concepts innovants, tandis que nos designers apportent la sensibilité, l'expertise et le raffinement nécessaires pour transformer ces idées en créations exceptionnelles.
                                    </p>
                                    <p className="design-card-text">
                                        Chaque visuel est retouché, optimisé et pensé par la suite créative humaine, pour garantir une cohérence parfaite et une identité unique adaptée à votre univers.
                                    </p>
                                    <p className="design-card-text">
                                        Cette méthode permet de dépasser les limites de la création classique et d'offrir à chaque projet originalité percutante et rapidité d'exécution unique.
                                    </p>
                                </div>

                                {/* Card 4 */}
                                <div className="design-card design-card-right">
                                    <h2 className="design-card-title">
                                        L'alliance <span className="design-card-highlight">parfaite</span> entre art, technologie et stratégie
                                    </h2>
                                    <p className="design-card-text">
                                        Nous ne faisons plus de simples créations visuelles, nous élaborons une stratégie graphique optimisée.
                                    </p>
                                    <p className="design-card-text">
                                        Chaque design est conçu pour plaire esthétiquement, mais aussi pour performer commercialement : attractivité, mémorabilité, conversion.
                                    </p>
                                    <p className="design-card-text">
                                        L'intelligence artificielle analyse les performances visuelles de vos concurrents, teste les combinaisons de couleurs et de typographies pour maximiser l'impact de vos supports.
                                    </p>
                                    <p className="design-card-text">
                                        Cette alliance entre créativité humaine et analyse algorithmique vous permet de bénéficier d'une identité visuelle à la fois sublime et stratégique validée par la data et vos objectifs de croissance.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Bottom CTA */}
                <section className="design-bottom-cta">
                    <button className="design-cta-button" onClick={() => navigate('/#contact')}>
                        Contactez nous
                    </button>
            </section>

            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default DesignGraphiquePage;
